import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export const getScans = () => axios.get(`${API}/scans`);
export const getLatestScan = () => axios.get(`${API}/scans/latest`);
export const getDefaultScan = () => axios.get(`${API}/scans/default`);
export const getOpportunitiesMulti = (scanIds) => {
  const [first, ...rest] = scanIds;
  const extra = rest.length ? `?extra_scan_ids=${rest.join(",")}` : "";
  return axios.get(`${API}/scans/${first}/opportunities${extra}`);
};
export const getOpportunities = (params) => axios.get(`${API}/opportunities`, { params });
export const getLocations = (scanId) => axios.get(`${API}/filters/locations`, { params: { scan_id: scanId } });
